import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";
import {initClientSearch} from "./clients.js";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT CLIENT SEARCH
    initClientSearch();

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        const isOpen = document.body.classList.toggle('body--show');
        menu_button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        menu_button.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
    })

    // INIT SEARCH TRIGGER
    const searchTrigger = document.querySelector('[data-behaviour="open-search"]');
    if (searchTrigger) {
        searchTrigger.addEventListener('click', () => {
            document.getElementById('searchbox_overlay').showModal();
        });
    }

    // INIT MULTISITE TOGGLE
    const multisiteToggle = document.querySelector('[data-behaviour="toggle-multisite"]');
    if (multisiteToggle) {
        const multisiteTrigger = multisiteToggle.querySelector('[data-behaviour="toggle-multisite-trigger"]');
        multisiteTrigger.addEventListener('click', () => {
            multisiteToggle.classList.toggle('header_multisitetoggle--open');
        });

        document.addEventListener('click', (event) => {
            if (!multisiteToggle.contains(event.target)) {
                multisiteToggle.classList.remove('header_multisitetoggle--open');
            }
        });
    }

    // INIT NAV SUBMENUS
    const navSubnavs = document.querySelectorAll('[data-behaviour="nav-subnav"]');
    const closeNavSubnav = (item) => {
        item.classList.remove('nav_item--open');
        item.querySelector('[data-behaviour="nav-subnav-toggle"]').setAttribute('aria-expanded', 'false');
    };
    // On desktop, the subnav also opens via CSS on :hover/:focus-within
    // (see header.scss) without going through the click-toggle below —
    // keep aria-expanded in sync with that visual state too.
    const isDesktop = window.matchMedia('(min-width: 1000px)');
    navSubnavs.forEach((item) => {
        const trigger = item.querySelector('[data-behaviour="nav-subnav-toggle"]');
        trigger.addEventListener('click', () => {
            const isOpen = item.classList.toggle('nav_item--open');
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        const syncExpandedOnLeave = (event) => {
            if (!isDesktop.matches) return;
            if (item.contains(event.relatedTarget)) return;
            if (item.classList.contains('nav_item--open')) return;
            trigger.setAttribute('aria-expanded', 'false');
        };
        item.addEventListener('mouseenter', () => {
            if (isDesktop.matches) trigger.setAttribute('aria-expanded', 'true');
        });
        item.addEventListener('mouseleave', syncExpandedOnLeave);
        item.addEventListener('focusin', () => {
            if (isDesktop.matches) trigger.setAttribute('aria-expanded', 'true');
        });
        item.addEventListener('focusout', syncExpandedOnLeave);
    });

    document.addEventListener('click', (event) => {
        navSubnavs.forEach((item) => {
            if (!item.contains(event.target)) {
                closeNavSubnav(item);
            }
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            navSubnavs.forEach((item) => {
                if (item.classList.contains('nav_item--open')) {
                    const trigger = item.querySelector('[data-behaviour="nav-subnav-toggle"]');
                    closeNavSubnav(item);
                    trigger.focus();
                }
            });
        }
    });

    // NAV OVERLAY (white backdrop growing behind the open desktop dropdown,
    // sized to the hovered item's number of subnav links)
    const navMenu = document.querySelector('.header_nav .nav_menu');
    const navOverlay = document.querySelector('.header_nav .nav_overlay');
    const NAV_SUBNAV_ITEM_HEIGHT = 32;
    if (navMenu && navOverlay) {
        navSubnavs.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                const count = item.querySelectorAll('.nav_subnav_item').length;
                navOverlay.style.height = (count * NAV_SUBNAV_ITEM_HEIGHT) + 'px';
            });
        });
        navMenu.addEventListener('mouseleave', () => {
            navOverlay.style.height = '0px';
        });
    }

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper:not(.swiper--teaser)');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // INIT TEASER SLIDER
    const teaserSliders = document.querySelectorAll('.swiper--teaser');
    teaserSliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const teaserSwiper = new Swiper(slider, {
            modules: [Pagination, Navigation, Autoplay],
            effect: 'slide',
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },

            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // INIT TEASER SLIDER
    const bigSliders = document.querySelectorAll('.swiper--big');
    bigSliders.forEach(function (slider) {
        const bigSwiper = new Swiper(slider, {
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,

            autoplay:  {
                delay: 5000,
            },
        });
    });

    // EMBED DISCLAIMER (external content consent)
    function activateEmbedScripts(root) {
        root.querySelectorAll('script').forEach((oldScript) => {
            const newScript = document.createElement('script');
            for (const attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
        });
    }

    function enableEmbeds() {
        document.querySelectorAll('.embed').forEach((embed) => {
            if (embed.dataset.activated) return;
            const template = document.createElement('template');
            template.innerHTML = embed.innerHTML;
            activateEmbedScripts(template.content);
            embed.after(template.content);
            embed.dataset.activated = '1';
        });
        document.querySelectorAll('.embed-disclaimer').forEach((disclaimer) => {
            disclaimer.style.display = 'none';
        });
    }

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }

    document.querySelectorAll('.approve-disclaimer').forEach((button) => {
        button.addEventListener('click', () => {
            enableEmbeds();
            setCookie('show-embeds', '1', 730);
        });
    });

    if (getCookie('show-embeds') === '1') {
        enableEmbeds();
    }

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });

    // REVEAL NAV ON FIRST INTERACTION (matches live site: nav bar fades in
    // once the user starts scrolling/moving the mouse/touching, not on load).
    // Opt-in per page via the "NavFadeIn" CMS checkbox (see Page.php / Page.ss).
    if (document.body.classList.contains('page--nav-fadein')) {
        const revealNav = () => {
            document.body.classList.add('body--navrevealed');
            window.removeEventListener('scroll', revealNav);
            window.removeEventListener('mousemove', revealNav);
            window.removeEventListener('touchstart', revealNav);
        };
        window.addEventListener('scroll', revealNav, { passive: true });
        window.addEventListener('mousemove', revealNav, { passive: true });
        window.addEventListener('touchstart', revealNav, { passive: true });
    }
});
